import { makeVar } from '@apollo/client'
import { IDateFilterVar } from 'context/types'

const DEFAULT_STATS_DATE_FILTER = { startDate: null, endDate: null }

export const graphDateRangeVar = makeVar<IDateFilterVar | typeof DEFAULT_STATS_DATE_FILTER>(
  DEFAULT_STATS_DATE_FILTER
)
